// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"92de30e3","53":"28c3eb13","213":"a480bfd1","239":"6e9eb262","453":"670e15c7","825":"04125332"}[chunkId] + ".chunk.js";
};